import {Component, ViewChild, Input, OnInit, OnDestroy} from "@angular/core";
import {Constant} from "../../constant";
import {DataService} from "../../service/data.service";
import {FileUploader} from "ng2-file-upload";
import {UserService} from "../../service/user.service";
import {DialogService} from "../../service/dialog.service";
import {TranslateService} from "@ngx-translate/core";
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EventManagerService } from '../../service/event-manager.service';
import { UploaderService } from "../../service/uploader.service";
import { Subscription } from "rxjs";

/**
 * declare Jquery
 * */
declare let $: any;

@Component({
  selector: 'upload-passport',
  templateUrl: "./upload-passport.html",
})

export class UploadPassport implements OnInit, OnDestroy {

  @Input('photos') photos: any;
  uploader1: FileUploader;
  uploader2: FileUploader;
  public Constant = Constant;
  cancel: () => void;
  isUploadFile = false;
  isUploadFile1 = false;
  images = null;
  images1 = null;
  defaultPhoto: string;
  namePhoto: string;
  defaultPhoto1: string;
  namePhoto1 : string;
  isRegister: boolean = false;
  isShow: boolean = false;
  refresh: boolean = false;
  isChange: any;
  isUpload1: boolean = false;
  isUpload2: boolean = false;
  subscriptions?: Subscription[] = [];
  @ViewChild('uploadLoadingModal', { static: true }) loadingModal : any;
  constructor(
    private eventManagerService: EventManagerService,
    private dataService: DataService,
    public userService: UserService,
    private dialog: DialogService,
    public activeModal: NgbActiveModal,
    private uploaderService: UploaderService,
    private eventManager: EventManagerService,
    private translate: TranslateService) {

  }
  ngOnDestroy(): void {
    this.eventManager.destroys(this.subscriptions);
  }
  ngOnInit() {
    this.isChange = false;
    this.defaultPhoto = this.photos[0] ? this.photos[0].url : '';
    this.namePhoto = this.photos[0] ? this.photos[0].fileName : '';
    this.defaultPhoto1 = this.photos[1] ? this.photos[1].url : '';
    this.namePhoto1 = this.photos[1] ? this.photos[1].fileName : '';
    this.isShow = true;
    if (this.isRegister) {
      this.showInRegister();
    } else {
      this.show();
    }
    this.subscriptions = [
      this.eventManager.subscribe('photo1-upload-file', (res) => {
        this.isUpload1 = true;
      }),
      this.eventManager.subscribe('photo1-upload-fail', (res) => {
        this.isUpload1 = false;
      }),
      this.eventManager.subscribe('photo1', (res) => {
        const imagePath = res.content.imagePath;
        const file = res.content.file;
        this.namePhoto = file.fileNameDisplay;
        this.defaultPhoto = imagePath + '?' + Date.now();
        this.isUpload1 = false;
        this.isChange = true;
        this.uploader1.clearQueue();
      }),
      this.eventManager.subscribe('photo2-upload-file', (res) => {
        this.isUpload2 = true;
      }),
      this.eventManager.subscribe('photo2-upload-fail', (res) => {
        this.isUpload2 = false;
      }),
      this.eventManager.subscribe('photo2', (res) => {
        const imagePath = res.content.imagePath;
        const file = res.content.file;
        this.namePhoto1 = file.fileNameDisplay;
        this.defaultPhoto1 = imagePath + '?' + Date.now();
        this.isUpload2 = false;
        this.isChange = true;
        this.uploader2.clearQueue();
      }),
    ];
    this.uploader1 = this.uploaderService.initUploader(
      Constant.api_upload_file, 'photo1', ['image', 'pdf']);
    this.uploader2 = this.uploaderService.initUploader(
      Constant.api_upload_file, 'photo2', ['image', 'pdf']);
  }
  close(isRegister?) {
    this.dismiss();
  }
  submit() {
    this.dismiss();
    this.eventManagerService.broadcast({
      name: 'upload-file-successfully',
      content: {
        photos: [{
          url: this.defaultPhoto,
          fileName: this.namePhoto,
          photoType: 'PASSPORT'
        }, {
          url: this.defaultPhoto1,
          fileName: this.namePhoto1,
          photoType: 'PASSPORT'
        }]
      }
    });
  }
  show() {
    this.uploader1 = new FileUploader({
      url: Constant.api_upload_file,
      authToken: this.dataService.token
    });
    this.uploader2 = new FileUploader({
      url: Constant.api_upload_file,
      authToken: this.dataService.token
    });
  }
  public showInRegister(personal?) {
    this.uploader1 = new FileUploader({
      url: Constant.api_upload_file_register,
      authToken: this.dataService.token
    });
    this.uploader2 = new FileUploader({
      url: Constant.api_upload_file_register,
      authToken: this.dataService.token
    });
  }
  dismiss() {
    this.activeModal.dismiss();
  }
}
